export const UPDATE_REDIRECT = 'fulcrum/Project/Update/UPDATE_REDIRECT'
